/**
 * Shipping Configuration
 *
 * Centralized shipping settings including free shipping thresholds,
 * flat rates, and delivery estimates.
 */

export const SHIPPING_CONFIG = {
	freeShippingThreshold: {
		eu: 500,
		us: 500,
	},
	flatRate: {
		eu: 12.99,
		us: 12.99,
	},
	minimumOrderValue: {
		eu: 70,
		us: 70,
	},
	deliveryDays: {
		min: 6,
		max: 12,
	},
	sameDayCutoffHour: 14,
} as const;

type ShippingRegion = keyof typeof SHIPPING_CONFIG.minimumOrderValue;

function shippingRegionForChannel(channel?: string): ShippingRegion {
	return channel?.toLowerCase().includes("us") ? "us" : "eu";
}

/** The cart subtotal is merchandise-only; delivery is never counted toward this minimum. */
export function isMinimumOrderSatisfied(merchandiseSubtotal: number, channel?: string): boolean {
	return (
		Number.isFinite(merchandiseSubtotal) &&
		merchandiseSubtotal >= SHIPPING_CONFIG.minimumOrderValue[shippingRegionForChannel(channel)]
	);
}

export function minimumOrderValueForChannel(channel?: string): number {
	return SHIPPING_CONFIG.minimumOrderValue[shippingRegionForChannel(channel)];
}
